import { layers } from '@jira/platform__ui-layers/src/layers.tsx';
import { token } from '@atlaskit/tokens';
import type { AkSelectStyles } from '@atlassian/jira-common-components-picker/src/model.tsx';

export const defaultSelectStyles: AkSelectStyles = {
	menuPortal: (base) => ({
		...base,
		zIndex: layers.modal,
	}),
	menu: (base) => ({
		...base,
		zIndex: layers.modal,
	}),
};

const inputIconPaddingLeft = token('space.025');
const inputIconPaddingRight = token('space.050');

export const indicatorFixSelectStyles: AkSelectStyles = {
	// need to apply same padding to both loadingIndicator and clearIndicator - not to have input query jumping between lines e.g. in multi-select
	loadingIndicator: (base) => ({
		...base,
		paddingLeft: inputIconPaddingLeft,
		paddingRight: inputIconPaddingRight,
	}),
	clearIndicator: (base) => ({
		...base,
		paddingLeft: inputIconPaddingLeft,
		paddingRight: inputIconPaddingRight,
	}),
};

// Styles to prevent loading indicator height shifts in Work Item View.
// The built-in loading indicator (animated dots) has vertical padding that can cause
// the select control to change height between loading and loaded states.
// Apply this only in WIV context to avoid affecting classic issue view.
export const workItemViewLoadingIndicatorFix: AkSelectStyles = {
	loadingIndicator: (base) => ({
		...base,
		paddingTop: 0,
		paddingBottom: 0,
	}),
};

export const inValidStyle: AkSelectStyles = {
	container: (base) => ({
		...base,
		border: `${token('border.width.selected')} solid ${token('color.border.danger')}`,
		borderRadius: token('radius.small'),
	}),
};
